import React, { PropTypes } from 'react';
import {Card, Icon} from 'antd'
import SharedTools from '../../../lib/SharedTools';
import ReactQiniuModule from '../../../../../lib/ReactQiniuModule';

class ObservationParagraph extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            img_url :this.props.img_url?this.props.img_url:"",
            paragraph:this.props.paragraph?this.props.paragraph:"",
            uploading:false,
        };

        this.thumbImg = this.thumbImg.bind(this)
        this.onFileStartUpload = this.onFileStartUpload.bind(this);
        this.onFileUploadSuccess = this.onFileUploadSuccess.bind(this);
        this.isAllUploadingFileFinished = this.isAllUploadingFileFinished.bind(this);
        this.onTextChange = this.onTextChange.bind(this)
    }

    thumbImg(Img_url) {
        return SharedTools.getThumbImageUrl(Img_url);
    }

    // beforeUpload(file) {
    //     const isJPG = file.type === 'image/jpeg';
    //     if (!isJPG) {
    //         message.error('You can only upload JPG file!');
    //     }
    //     return isJPG;
    // }

    onFileUploadSuccess(newFileKey, fileName, size, remoteUrl) {
        this.props.onImgUrlChange(remoteUrl,this.props.index);
        this.setState({ 
            img_url:remoteUrl,
            uploading: false,
         })
    }

    isAllUploadingFileFinished() {
        return !this.state.uploading;
    }
    
    onFileStartUpload(newFileKey) {
        this.setState({
          uploading: true
        })
        return true;
    }

    onTextChange(event) {
        this.props.onParagraphChange(event.target.value,this.props.index);
        this.setState({
          paragraph: event.target.value
        });
    }
    render(){
        let{goDeleteParagraph,index} = this.props
        return(
            <Card className='observation-paragraph' bodyStyle={{ padding: 15 }}>
                <div className="uploading-module-container">
                    <ReactQiniuModule
                        className="uploading-module"
                        onSuccess={this.onFileUploadSuccess}
                        onStartPermit={this.onFileStartUpload}
                        isAllFinish={this.isAllUploadingFileFinished}
                        getUploadQuota={() => {return !this.state.uploading}}
                        allowUploadFileTypes={ReactQiniuModule.getFileCategories.IMAGES}
                        allowUploadFileSize={10} >
                        {
                            this.state.img_url ?
                            <img src={this.thumbImg(this.state.img_url)} alt=""  className="img"/>:
                            <div className='avatar-uploader'>
                                <Icon type="plus" className="avatar-uploader-trigger" />
                            </div>
                        }
                    </ReactQiniuModule>

                </div>
                <textarea className='text' placeholder={`输入观测内容...`} value={this.state.paragraph} onChange={this.onTextChange}></textarea>
                <Icon type="close" className="delete-btn" onClick={(event) => {goDeleteParagraph(index)}}/>
            </Card>
        )
    }



}
export default ObservationParagraph;


// WEBPACK FOOTER //
// ./app/javascript/bundles/WebPcApp/components/development/commonComponent/ObservationParagraph.jsx